import { ThemeProvider } from 'styled-components';
import { GlobalStyle, lightTheme } from '@higo/ui';
import { AppRouter } from 'AppRouter';

const App = () => (
  <ThemeProvider theme={lightTheme}>
    <GlobalStyle />
    <AppRouter />
  </ThemeProvider>
);

export default App;
